import React, { Component, Fragment } from 'react'
import {
  Button,
} from "reactstrap";
import Moment from "react-moment";
import * as common from "../../lib/common";

export default class OrderCustomerInfo extends Component {
  render() {
    const {
      orderInfor,
      isLocking,
      msgLocking,
      isEditable,
      className,
      showMoreClass,
      isShowMoreContent,
      onCustomerClick,
    } = this.props
    const faIconBaseState = isShowMoreContent ? 'fa-caret-down' : 'fa-caret-up'
    const renderListCustomer = (addedCustomers) => {
      if (!addedCustomers || addedCustomers.length === 0) {
        return null
      }
      const items = addedCustomers.map((item) => {
        return (
          <li className="item list-group-item p-1" key={item.Id}>
            <div className="font-weight-bold">
              <a title={"Click để xem lịch sử"} className={"text-primary mr-1 pointer"} onClick={() => onCustomerClick(item.Id)}>
                <i className={"fa fa-eye mr-1"}></i>
                {common.getCustomerMarketingStatusText(item.TrangThai, true)}
              </a>
              <span>{item.Ma}/ {item.Ten}</span>
            </div>
            <span className={"item_unit text-muted pl-1"}>{item.DiaChi}</span>
          </li>
        )
      })
      return items
    }
    return (
      <div className={`col-sm-12 ${className}`}>
        {isLocking && (
          <div className="col-sm-12 mb-1 view-row">
            <span className="text-danger mr-1">{msgLocking}</span>&nbsp;
            {isEditable && (
              <Button className="btn btn-link mr-1" onClick={() => this.props.unlockOrder(orderInfor)}>
                Huỷ
              </Button>
            )}
          </div>
        )}
        <div className="col-sm-12 mb-1 view-row">
          <span>Kho xuất: <b>{orderInfor.ten_kho}</b></span>
        </div>
        {orderInfor.ten_nguoi_sua && (
          <Fragment>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Người sửa: <b>{orderInfor.ten_nguoi_sua}</b></span>
            </div>
            <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
              <span>Ngày sửa: <b><Moment format="HH:mm DD/MM">{`${orderInfor.ngay_sua}`}</Moment></b></span>
            </div>
          </Fragment>
        )}
        <div className={`col-sm-12 mb-1 view-row ${showMoreClass}`}>
          <div>Khách hàng: </div>
          <ul className="list-group order-lst-customer">
            {renderListCustomer(orderInfor.added_customers)}
          </ul>
        </div>
        <div title={'Click để xem thêm/bớt thông tin'} className={`col-sm-12 mb-1 order-show-button`} onClick={() => this.props.setShowHide()}>
          <span className={`fa ${faIconBaseState} fa-2x`}></span>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/MarketingOrder/_OrderCustomerInfo.js